import { render, staticRenderFns } from "./DetailBLog.vue?vue&type=template&id=68f57f1b&"
import script from "./DetailBLog.vue?vue&type=script&lang=js&"
export * from "./DetailBLog.vue?vue&type=script&lang=js&"
import style0 from "./DetailBLog.vue?vue&type=style&index=0&id=68f57f1b&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68f57f1b')) {
      api.createRecord('68f57f1b', component.options)
    } else {
      api.reload('68f57f1b', component.options)
    }
    module.hot.accept("./DetailBLog.vue?vue&type=template&id=68f57f1b&", function () {
      api.rerender('68f57f1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/DetailBLog.vue"
export default component.exports